<template>
  <section>
    <modal :title="title" :show="showModal" @close="closeModal()">
      <div class="content" slot="content">
        <validation-observer ref="form">
        <form>
          <div class="margin-top-l item">
            <p>
              Saldo máximo liberado para saque: <b>{{ maxValue | money }}</b>
            </p>
            <p>
              <small><b>Atenção:</b> Valor minímo para saque: <b>{{ minvalue | money }}</b></small>
            </p>
          </div>
          <div class="margin-top-l">
            <validation-provider
              name="Valor do Saque"
              rules="required"
              v-slot="{ errors }"
            >
              <div
                class="form-field item group-input "
                :class="{ errors: errors[0] }"
              >
                <label>
                  Valor:
                </label>
                <money v-model="newWithdraw.value" :key="testeKey" v-bind="money"></money>
                <span class="erros-alert">{{ errors[0] }}</span>
              </div>
            </validation-provider>
          </div>
        </form>
      </validation-observer>
      </div>
      <div class="action" slot="action">
        <div class="flex center">
          <button @click="closeModal()" class="button secondary medium">
            Voltar
          </button>
          <button
            type="submit"
            @click="acceptModal()"
            class="button primary medium"
            :class="{ unusual: unusual == 'accept' }"
          >
            {{ isEdit ? "Editar" : "Solicitar Saque" }}
          </button>
        </div>
      </div>
    </modal>
  </section>
</template>

<script>
import Modal from "@/components/modal/Modal";
import { Money } from 'v-money'

export default {
  name: "modal-withdraw",
  props: {
    titleName: {
      required: false,
      default: "Solicitar Saque",
    },
    show: {
      required: true,
      default: false,
    },
    unusual: {
      required: false,
      default: "false",
    },
    maxValue: {
      required: true,
      default: 0
    }
  },
  components: {
    Modal,
    Money
  },
  data() {
    return {
      minvalue: 50,
      showDeleteModal: false,
      selectModalDelete: null,
      showModal: false,
      seenGuide: {},
      testeKey: 0,
      newWithdraw: {
        value: 0
      },
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false
      },
      title: "Solicitar Saque",
    };
  },
  watch: {
    show(value) {
      this.showModal = value;
    },
    newWithdraw: {
      handler(v) {
        if (v.value < 0) {
          this.newWithdraw.value = 0
          this.testeKey = this.testeKey + 1

          this.$toast.error({
            title:'Erro',
            message:'O valor de saque não pode ser negativo'
          })
        } else if ( v.value > this.maxValue) {
          this.newWithdraw.value = this.maxValue
          this.testeKey = this.testeKey + 1

          this.$toast.error({
            title:'Erro',
            message:'O valor do saque é maior que seu saldo.'
          })
        }
      },
      deep: true
    }
  },
  updated() {
    this.newWithdraw.value = this.maxValue 
  },
  mounted() {
    this.newWithdraw.value = this.maxValue 
  },
  computed: {
    isEdit() {
      return false;
    },
  },
  methods: {
    acceptModal() {
      this.showModal = false;
      this.$emit("accept", this.newWithdraw);
    },
    closeModal() {
      this.showModal = false;
      this.$emit("close", false);
    },
  },
};
</script>

<style lang="scss" scoped>
.action {
  margin-top: 30px;
  .button {
    margin-left: 10px !important;
  }
}

textarea {
  border-radius: 5px;
  border: 1px solid #3333;
  padding: 15px;
  max-width: 500px;
  min-width: 500px;
  min-height: 150px;
  max-height: 150px;
}

ul {
  list-style: none;
  max-height: 200px;
  overflow-y: scroll;
  li {
    padding: 4px 8px;
    border-bottom: 1px solid #ccc;
    .tag {
      background: #c2c2c2;
      padding: 4px 6px;
      border-radius: 5px;
      font-size: 11px;
      font-weight: 800;
      margin-left: 8px;
    }
    .button {
      margin-left: 4px;
      padding: 4px 6px;
    }
  }
}
</style>
